"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Fraserland Organics
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 2.1.10-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DailySummaryBodyToJSON = exports.DailySummaryBodyFromJSONTyped = exports.DailySummaryBodyFromJSON = void 0;
function DailySummaryBodyFromJSON(json) {
    return DailySummaryBodyFromJSONTyped(json, false);
}
exports.DailySummaryBodyFromJSON = DailySummaryBodyFromJSON;
function DailySummaryBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'day': json['day'],
        'month': json['month'],
        'year': json['year'],
    };
}
exports.DailySummaryBodyFromJSONTyped = DailySummaryBodyFromJSONTyped;
function DailySummaryBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'day': value.day,
        'month': value.month,
        'year': value.year,
    };
}
exports.DailySummaryBodyToJSON = DailySummaryBodyToJSON;
